import { render, staticRenderFns } from "./batchUpdata.vue?vue&type=template&id=5f9004e6&scoped=true"
import script from "./batchUpdata.vue?vue&type=script&lang=js"
export * from "./batchUpdata.vue?vue&type=script&lang=js"
import style0 from "./batchUpdata.vue?vue&type=style&index=0&id=5f9004e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9004e6",
  null
  
)

export default component.exports